import React from 'react';

export const Blog = () => {
	return (
		<div className='page-content mt-main ph-main pv-page-content'>
			<h1 className='header text-center'>Незабаром оновимо!</h1>
		</div>
	);
};
